import { create } from "zustand"

type SidebarChromeState = {
  isCollapsed: boolean
  collapse: () => void
  expand: () => void
}

export const useSidebarStore = create<SidebarChromeState>()((set) => ({
  isCollapsed: false,
  collapse: () => set({ isCollapsed: true }),
  expand: () => set({ isCollapsed: false })
}))
